<template>
  <div class="cb-pheader__wrap">
  	<div class="cb-pheader__logo">
	    <cb-placeholder :custom-class="'xl rect-sm center'"></cb-placeholder>
		</div>
		<div class="cb-pheader__content">
      <cb-placeholder :custom-class="'st rect-xl mobile'"></cb-placeholder>
		</div>
  </div>
</template>
<script type="text/javascript">
import Placeholder from "@/components/collections/elements/Placeholder"
import Button from "@/components/collections/form/ButtonComponent"
export default {
  components: {
    'cb-placeholder': Placeholder,
    'cb-button' : Button,
  },
}
</script>